<template>
    <teleport to="body">
        <div v-if="show" class="backdrop dialog_backdrop" :class="{ dialog_pop_up_backdrop: dialogPopUp }"></div>
        <transition name="dialog">
            <dialog ref="dialogElem" open v-if="show" :style="customBodyStyle" :class="
                { 
                    draggable_dialog: draggable, 
                    large: large, 
                    medium: medium, 
                    xlarge: xlarge, 
                    xxlarge: xxlarge, 
                    large_position: large, 
                    xlarge_position: xlarge, 
                    medium_position: medium, 
                    long_dialog: longDialog, 
                    xxlarge_position: xxlarge, 
                    dialog_radius: !hasFooter, 
                    dialog_pop_up: dialogPopUp, 
                    overflow_visible: allowOverflow
                }"
            >
                <header :style="customHeaderStyle" :class="
                    {
                        large: large, 
                        medium: medium, 
                        xlarge: xlarge, 
                        xxlarge: xxlarge, 
                        draggable_header: draggable, 
                        warning_header: warningDialog
                    }" @mousedown="(e) => dragDialog(e)" 
                >
                    <h3>
                        {{ dialogTitle }}
                    </h3>
                    <span v-if="!warningDialog" class="icon material-icons" @click="closeModal">close</span>
                </header>
                <section class="dialog_body" :class="{ warning_dialog_body: warningDialog, dialog_pop_up_body: dialogPopUp }">
                    <slot></slot>
                </section>
                <footer v-if="hasFooter" :style="customFooterStyle" :class="
                    {
                        large: large, 
                        xlarge: xlarge, 
                        medium: medium, 
                        xxlarge: xxlarge, 
                        footer_radius: hasFooter
                    }"
                >
                    <button-base 
                        form-id="form" 
                        xxsmall="xxsmall" 
                        button-type="submit" 
                        button-class="primary" 
                        :button-text="footerButtonText" 
                    ></button-base>
                </footer>
            </dialog>
        </transition>
    </teleport>
</template>

<script>
export default {
    props: [
        "show", 
        "large", 
        "xlarge", 
        "medium", 
        "xxlarge", 
        "hasFooter", 
        "draggable", 
        "longDialog", 
        "dialogPopUp", 
        "dialogTitle", 
        "allowOverflow", 
        "warningDialog", 
        "customBodyStyle", 
        "footerButtonText", 
        "customHeaderStyle", 
        "customFooterStyle"
    ],
    emits: ["closeModal"],
    data() {
        return {
            offsetTop: 0,
            offsetLeft: 0,
            startXCordinate: 0,
            startYCordinate: 0,
            currentDialog: null
        }
    },
    methods: {
        closeModal() {
            this.$emit("closeModal");
        },
        dragDialog(event) {
            if (!this.draggable) return; 

            this.currentDialog = this.$refs.dialogElem;

            this.moveModal(event);
        },
        moveModal(event) {
            this.startXCordinate = event.clientX;
            this.startYCordinate = event.clientY;

            if (this.currentDialog) {
                const rect = this.currentDialog.getBoundingClientRect();

                this.offsetTop = rect.top;
                this.offsetLeft = rect.left;
            }

            document.addEventListener("mousemove", this.dragContinue);
            document.addEventListener("mouseup", this.dragComplete);
        },
        dragContinue(event) {
            if (this.currentDialog) {
                const containerRect = this.currentDialog.parentElement.getBoundingClientRect();
                
                const newLeft = event.clientX - containerRect.left - (this.currentDialog.offsetWidth / 2);
                const newTop = event.clientY + 186 - (this.currentDialog.offsetHeight / 2);
                
                this.currentDialog.style.left = `${newLeft}px`;
                this.currentDialog.style.top = `${newTop}px`;
            }
        },
        dragComplete() {
            document.removeEventListener("mousemove", this.dragContinue);
            document.removeEventListener("mouseup", this.dragComplete);
            
            this.currentDialog = null;
        }
    }
}
</script>

<style scoped>
dialog {
    margin: 0;
    top: 13vh;
    padding: 0;
    z-index: 100;
    border: none;
    position: fixed;
    overflow: hidden;
    background-color: white;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
}

.dialog_radius {
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
}

.dialog_pop_up {
    top: 17vh;
    z-index: 120;
}

header {
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
}

.footer_radius {
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
}

header, footer {
    display: flex;
    position: fixed;
    padding: 0 18px;
    align-items: center;
    background-color: white;
    justify-content: space-between;
    border-bottom: 1px solid var(--sniffer-color-border);
}

header span {
    color: var(--sniffer-color-icon-small);
    cursor: pointer;
}

.draggable_header {
    cursor: move;
}

.warning_header {
    height: 9px;
    display: block !important;
    background-color: var(--sniffer-color-secondary);
}

.xxlarge {
    width: 70%;
    min-width: 70%;
}

.xlarge {
    width: 58%;
    min-width: 58%;
}

.large {
    width: 48%;
    min-width: 48%;
}

.medium {
    width: 41%;
    min-width: 41%;
}

.xxlarge_position {
    left: 17%;
}

.xlarge_position {
    left: 23%;
}

.large_position {
    left: 27.6%;
}

.medium_position {
    left: 31.2%;
}

.overflow_visible {
    overflow: visible !important;
}

.dialog_body {
    width: 100%;
    padding: 18px;
    margin-top: 60px;
    overflow-y: auto;
    max-height: 630px;
}

.dialog_pop_up_body {
    max-height: 390px;
}

.warning_dialog_body {
    margin-top: 0 !important;
}

footer {
    padding: 12px 18px;
    justify-content: end;
    border-top: 1px solid var(--sniffer-color-border);
}

.dialog-enter-from,
.dialog-leave-to {
    opacity: 0;
    transform: scale(0.8);
}

.dialog-enter-active {
    transition: all 0.3s ease-out;
}

.dialog-leave-active {
    transition: all 0.3s ease-in;
}

.dialog-enter-to,
.dialog-leave-from {
    opacity: 1;
    transform: scale(1);
}

@media (max-width: 1536px) {
    dialog {
        top: 8vh;
    }

    .dialog_body {
        max-height: 582px;
    }

    .xxlarge {
        width: 67%;
        min-width: 67%;
    }

    .xlarge {
        width: 61%;
        min-width: 61%;
    }

    .large {
        width: 52%;
        min-width: 52%;
    }

    .medium {
        width: 40%;
        min-width: 40%;
    }

    .xxlarge_position {
        left: 19%;
    }

    .xlarge_position {
        left: 21.3%;
    }

    .large_position {
        left: 26%;
    }

    .medium_position {
        left: 31.8%;
    }
}

@media (max-width: 1281px) {
    dialog {
        top: 7vh;
    }

    .long_dialog {
        top: 2vh;
    }

    .dialog_body {
        max-height: 408px;
    }

    .dialog_pop_up {
        top: 10vh;
    }

    .xxlarge {
        width: 65%;
        min-width: 65%;
    }

    .xlarge {
        width: 60%;
        min-width: 60%;
    }

    .large {
        width: 53%;
        min-width: 53%;
    }

    .medium {
        width: 42%;
        min-width: 42%;
    }

    .xxlarge_position {
        left: 19%;
    }

    .xlarge_position {
        left: 21.3%;
    }

    .large_position {
        left: 26%;
    }

    .medium_position {
        left: 30.2%;
    }
}
</style>